import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { FormField } from "../Form/FormField";
import { LoginError } from "./LoginError";
import { buttonText, placeholderText, errorMessageText } from "../../lib/constants";

export const LoginFormFields = ({
  values,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
  errors,
  touched,
}) => {
  const alertErrors = errors.global_error
   

  return (
    <Form onSubmit={handleSubmit}>
      <LoginError error={alertErrors} title={errorMessageText.error_title} />
      <FormField
        type="email"
        placeholder={placeholderText.email}
        name="email"
        error={alertErrors}
        touched={touched.email || alertErrors}
        handleBlur={handleBlur}
        handleChange={handleChange}
        value={values.email}
      />

      <div className="d-grid gap-2">
        <Button
          disabled={isSubmitting || !values.email}
          variant="primary"
          type="submit"
          className="mt-3"
        >
          {isSubmitting && (
            <div>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">
                  {buttonText.processing}
                </span>
              </Spinner>
            </div>
          )}

          {!isSubmitting && (
            <div>
              {buttonText.login}
            </div>
          )}
        </Button>
      </div>
    </Form>
  );
};

LoginFormFields.propTypes = {};